import request from '../http/request'
// 发送短信验证码
export function onSendSms (data, showLoading = false) {
  return request({
    url: '/web/smsVerificationCode', // 请求地址
    method: 'POST', // 请求方式
    data, // 参数
    showLoading // 是否显示加载状态，默认不显示
  })
}
// 个人用户信息注册
export function registeredUser (data) {
  return request({
    url: '/login/registeredSchool',
    method: 'POST',
    data
  })
}
// 登录
export function chnEngLoginRequest (data) {
  return request({
    url: '/mobileLoginWeb',
    method: 'POST',
    data
  })
}
// 邮箱密码登录

export function chnEngLogWithPassword (data) {
  return request({
    url: '/loginWeb',
    method: 'POST',
    data
  })
}
// 退出登录
export function loginOutRequest (params) {
  return request({
    url: '/loginOut',
    method: 'GET',
    params
  })
}

// 获取用户信息
export function getSysUserInfo (params) {
  return request({
    url: '/user/getSysUserInfo',
    method: 'GET',
    params
  })
}
// 获取学校信息
export function getUserInformation (params) {
  return request({
    url: '/user/getUserInformation',
    method: 'GET',
    params
  })
}
// 修改学校信息
export function updateSchoolInfo (data) {
  return request({
    url: '/school/updateSchoolInfo',
    method: 'POST',
    data
  })
}
// 查询用户收货地址
export function getUserAddressDefault (params) {
  return request({
    url: '/userAddress/getUserAddressDefault',
    method: 'GET',
    params
  })
}
// 查询学校列表
export function getSchoolList (params) {
  return request({
    url: '/web/getSchoolList',
    method: 'GET',
    params
  })
}
// 用户资料保存信息接口
export function saveSysUserInfo (data) {
  return request({
    url: '/user/saveSysUserAll',
    method: 'POST',
    data
  })
}
// 个人报名订单界面确认用户信息保存
export function saveSysUserInfoAddress (data) {
  return request({
    url: '/user/saveSysUserInfoAddress',
    method: 'POST',
    data
  })
}
// 个人赛试卷考量申请
export function savePersonalPaperApply (data) {
  return request({
    url: '/paper/v2/savePersonalPaperApply',
    method: 'POST',
    data
  })
}
// 学校注册
export function registeredSchool (data) {
  return request({
    url: '/web/registeredSchool',
    method: 'POST',
    data
  })
}
// 校验用户信息是否完善
export function checkSysUserInfo (params) {
  return request({
    url: '/user/checkSysUserInfo',
    method: 'GET',
    params
  })
}
// 获取俱乐部列表
export function getClubList (params) {
  return request({
    url: '/club/getClubList',
    method: 'GET',
    params
  })
}
// 获取战队列表
export function getTeamListByActivityType (params) {
  return request({
    url: '/team/getTeamListByActivityType',
    method: 'GET',
    params
  })
}
// 获取赛季列表
export function getSeasonActivityList (params) {
  return request({
    url: '/season/getSeasonActivityList/' + '1',
    method: 'GET',
    params
  })
}
// 获取赛季信息
export function getSeasonActivityIng (params) {
  return request({
    url: '/season/getSeasonActivityIng/' + '1',
    method: 'GET',
    params
  })
}
// 团体赛学校报名
export function saveTeamClub (data) {
  return request({
    url: '/team/saveTeamClub',
    method: 'POST',
    data
  })
}

// 个人参赛校报名
export function savePersonalSchool (data) {
  return request({
    url: '/enrollment/enrollmentPersonalSchool',
    method: 'POST',
    data
  })
}
// 订单界面获取战队信息
export function getTeamInfo (params) {
  return request({
    url: '/team/getTeamInfo',
    method: 'GET',
    params
  })
}
// 查询学校是否参加个人赛
export function getIsSchoolPersonexport (params) {
  return request({
    url: '/enrollment/getIsSchoolPerson',
    method: 'GET',
    params
  })
}
// 获取个人参赛校详细信息
export function getEnrollmentInfo (params) {
  return request({
    url: '/enrollment/getEnrollmentInfo',
    method: 'GET',
    params
  })
}
// 获取绑定学校信息
export function getSchoolInfo (params) {
  return request({
    url: '/school/getSchoolInfo',
    method: 'GET',
    params
  })
}
// 获取申请考量进度
export function queryPreliminaryProcessInfo (params) {
  return request({
    url: '/process/queryPreliminaryProcessInfo',
    method: 'GET',
    params
  })
}
// 保存用户收货地址
export function saveUserAddress (data) {
  return request({
    url: '/userAddress/saveUserAddress',
    method: 'POST',
    data
  })
}
//  获取要支付的产品内容
export function getTbProductSingle (params) {
  return request({
    url: '/product/getTbProductSingle',
    method: 'GET',
    params
  })
}
// 获取要支付的产品内容
// export function getTbProductSingle (params) {
//   return request({
//     url: '/product/getTbProductSingle/SpecsInfo',
//     method: 'GET',
//     params
//   })
// }
// 获取微信支付内容
export function creatTbProductOrder (data) {
  return request({
    url: '/order/creatTbProductOrder',
    method: 'POST',
    data
  })
}
// 点击完成支付按钮事件
export function getTbProductOrderIsFinish (data) {
  return request({
    url: '/order/getTbProductOrderIsFinish',
    method: 'POST',
    data
  })
}
// 获取学校参加个人赛考量申报订单
export function getPersonalPaperApplyList (params) {
  return request({
    url: '/paper/getPersonalPaperApplyList',
    method: 'GET',
    params
  })
}
// 获取学校申请考卷详情
export function getPersonalPaperApplyInfo (params) {
  return request({
    url: '/paper/v2/getPersonalPaperApplyInfo',
    method: 'GET',
    params
  })
}

// 审核学校试卷申请
export function confirmToSendBack (data) {
  return request({
    url: '/paper/confirmToSendBack',
    method: 'POST',
    data
  })
}

// 线下成绩信息查询
export function queryPaperResultScore (params) {
  return request({
    url: '/paper/queryPaperResultScore',
    method: 'GET',
    params
  })
}

// 获取课程二级联动类型
export function secondaryLinkageCourseQuery (data) {
  return request({
    url: '/course/secondaryLinkageCourseQuery',
    method: 'POST',
    data
  })
}

// 获取课程产品列表
export function haveBeenOpenedCourse (params) {
  return request({
    url: '/course/haveBeenOpenedCourse',
    method: 'GET',
    params
  })
}
// 获取已开通课程接口
export function queryOpenCourseList (params) {
  return request({
    url: '/course/queryOpenCourseList',
    method: 'GET',
    params
  })
}

// 根据typeid 获取课程
export function queryCourseQueryList (params) {
  return request({
    url: '/course/queryCourseQueryList',
    method: 'GET',
    params
  })
}
// 获取用户绑定的学校
export function getUserSchoolList (params) {
  return request({
    url: '/user/getUserSchoolList',
    method: 'GET',
    params
  })
}

// 获取用户开通课程
export function queryOpenCourseQueryList (params) {
  return request({
    url: '/course/queryOpenCourseQueryList',
    method: 'GET',
    params
  })
}

// 个人赛考量申请接口
// 获取申请考量详情
export function getInfoSeason (params) {
  return request({
    url: '/paper/v2/getInfoSeason',
    method: 'GET',
    params
  })
}
// 查询学校列表
export function getAllSchoolList (params) {
  return request({
    url: '/web/getAllSchoolList',
    method: 'GET',
    params
  })
}
// 个人赛考量申请接口

// ========== 机构相关接口 ==========
// 机构登录
export function partnerLoginRequest (data, showLoading = true) {
  return request({
    url: '/partner/login',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 发送重置密码验证码
export function sendPartnerResetPasswordCode (data, showLoading = true) {
  return request({
    url: '/partner/sendResetPasswordCode',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 重置密码
export function partnerResetPassword (data, showLoading = true) {
  return request({
    url: '/partner/resetPassword',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取机构信息
export function getPartnerInfo (params, showLoading = true) {
  return request({
    url: '/partner/info',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 更新机构信息
export function updatePartnerInfo (data, showLoading = true) {
  return request({
    url: '/partner/info',
    method: 'PUT',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}
// 发送邮箱验证码
export function sendPartnerEmailCode (data, showLoading = true) {
  return request({
    url: '/mail/sendMail',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 邮箱验证码登录
export function partnerEmailLogin (data, showLoading = true) {
  return request({
    url: '/loginWebEmailVerificationCode',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 兑换码列表
export function getCodeList (params, showLoading = true) {
  return request({
    url: '/overseasMatchCode/queryConversionCodeList',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}
//
// 兑换码导出
export function exportCodeList (params, showLoading = true) {
  return request({
    url: '/overseasMatchCode/exportConversionCodeList',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 海外学校班级学生列表
export function getOverseasSchoolStudentList (params, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/getList',
    method: 'GET',
    params,
    showLoading
  })
}

// 新增海外学生
export function createOverseasSchoolStudent (data, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/create',
    method: 'POST',
    data,
    showLoading
  })
}

// 编辑海外学生
export function editOverseasSchoolStudent (data, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/edit',
    method: 'POST',
    data,
    showLoading
  })
}

// 删除（单个/批量）海外学生
export function deleteOverseasSchoolStudent (data, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/del',
    method: 'POST',
    data,
    showLoading
  })
}

// 下载海外学生模板（返回下载地址）
export function downloadOverseasSchoolStudentTemplate (params, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/downloadExcel',
    method: 'GET',
    params,
    showLoading
  })
}

// 批量导入海外学生（文件流）
export function importOverseasSchoolStudent (data, showLoading = true) {
  return request({
    url: '/overseasSchoolStudent/importExcel',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    showLoading
  })
}
// 查询指定赛程参赛资格
export function querySeasonRaceSchedule (params, showLoading = true) {
  return request({
    url: '/overseasMatchCode/getEnrollment',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 兑换码解锁指定赛程赛事
export function dealWithConversionCode (data, showLoading = true) {
  return request({
    url: '/overseasMatchCode/dealWithConversionCode',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取用户基础信息
export function getBasicsUserInfo (data, showLoading = true) {
  return request({
    url: '/user/getBasicsUserInfo',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取国籍列表
export function getCountryList (params, showLoading = true) {
  return request({
    url: '/common/countryList',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 保存用户信息
export function saveBasicsUserInfo (data, showLoading = true) {
  return request({
    url: '/overseasMatchCode/saveBasicsUser',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}
// 上传文件
export function uploadFile (data, showLoading = true) {
  return request({
    url: '/upload/uploadFileAliOss',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    showLoading // 是否显示加载状态，默认显示
  })
}

// 检查用户信息是否完善
export function checkBasicsUserInfo (params, showLoading = true) {
  return request({
    url: '/overseasMatchCode/checkBasicsUserInfo',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 申请兑换码
export function applyUnlockCode (data, showLoading = true) {
  return request({
    url: '/overseasMatchCode/apply',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}
// 获取未读消息数量
export function getUnreadMessageCount (params, showLoading = true) {
  return request({
    url: '/noticeMailUser/nreadNum',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取消息列表
export function getMessageList (params, showLoading = true) {
  return request({
    url: '/noticeMailUser/readPage',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 读取信息
export function readMessage (data, showLoading = true) {
  return request({
    url: '/noticeMailUser/readNoticeMail',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取报名信息列表
export function getEnrollmentInfoList (params, showLoading = true) {
  return request({
    url: '/enrollment/queryFormTbEnrollmentList',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 给C端发送兑换码邮件
export function sendEmailCode (data, showLoading = true) {
  return request({
    url: '/overseasMatchCode/sendCodeToEmail',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 申请成为组委会
export function applyOverseasCommittee (data, showLoading = true) {
  return request({
    url: '/common/overseasCommitteeApply/apply',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 查询申请进度接口
export function selectByQueryCode (params, showLoading = true) {
  return request({
    url: '/common/overseasCommitteeApply/selectByQueryCode',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 获取用户下的组委会列表
export function getOverseasUserDistrictList (params, showLoading = true) {
  return request({
    url: '/overseasUserDistrict/queryList',
    method: 'GET',
    params,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 创建区域赛赛程参赛资格
export function createEnrollment (data, showLoading = true) {
  return request({
    url: '/overseasMatchCode/createEnrollment',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 删除赛程参赛资格
export function deleteTbEnrollment (data, showLoading = true) {
  return request({
    url: '/enrollment/deleteTbEnrollment',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

// 设置晋级
export function setPromotion (data, showLoading = true) {
  return request({
    url: '/enrollment/setTbEnrollmentPromotion',
    method: 'POST',
    data,
    showLoading // 是否显示加载状态，默认显示
  })
}

/**
 * 国赛相关接口
 */
// 获取赛区信息列表
export function queryDistrictPage (params) {
  return request({
    url: '/district/queryDistrictPage',
    method: 'GET',
    params
  })
}
// 查询线下考场考位
export function queryExaminationListPage (params) {
  return request({
    url: '/examination/queryExaminationListPage',
    method: 'GET',
    params
  })
}
// 重置考场内的某个学生
export function resetSingleUser (id) {
  return request({
    url: `/examinationUser/removeExaminationRoomUser/${id}`,
    method: 'POST'
  })
}
// 重置考场内所有学生
export function resetAllUser (examinationId) {
  return request({
    url: `/examinationUser/removeExaminationRoomAllUser/${examinationId}`,
    method: 'POST'
  })
}
// 查询本组别未选择考场【线下-线上】学生
export function queryUnselectedRoomUserList (params) {
  return request({
    url: '/examinationUser/queryUnselectedRoomUserList',
    method: 'GET',
    params
  })
}
// 批量添加
export function batchExaminationRoom (data) {
  return request({
    url: '/examinationUser/batchExaminationRoom',
    method: 'POST',
    data
  })
}
// 线上成绩设置晋级国赛
export function setTbEnrollmentPromotion (data) {
  return request({
    url: '/enrollment/setTbEnrollmentPromotion',
    method: 'POST',
    data
  })
}
// 线下成绩设置晋级-复赛
export function setFinalsPromotion (data) {
  return request({
    url: '/enrollment/setTbEnrollmentPromotion',
    method: 'POST',
    data
  })
}
// 线上成绩第一轮设置晋级
export function setTbEnrollmentRoundPromotion (data) {
  return request({
    url: '/enrollmentRoundInfo/edit',
    method: 'POST',
    data
  })
}
// 国赛列表
export function queryTbEnrollmentNationalList (params) {
  return request({
    url: '/overseasEnrollment/queryTbEnrollmentNationalList',
    method: 'GET',
    params
  })
}
// 根据省市区查询学校
export function getSchoolListWithCity (params) {
  return request({
    url: '/school/getSchoolList',
    method: 'GET',
    params
  })
}

// 获取产品信息
export function getTbProductDetailList (params) {
  return request({
    url: '/product/getTbProductDetailList',
    method: 'GET',
    params
  })
}

// 确认线下支付
export function confirmPayV2 (data) {
  return request({
    url: '/overseasEnrollment/confirmPayV2',
    method: 'POST',
    data
  })
}

// 获取用户地址列表
export function getSysUserAddressListByUserId (params, showLoading = true) {
  return request({
    url: '/user/getSysUserAddressListByUserId',
    method: 'GET',
    params,
    showLoading
  })
}

// 查询报名列表
export function queryTbEnrollmentList (params, showLoading = true) {
  return request({
    url: '/enrollment/queryFormTbEnrollmentList',
    method: 'GET',
    params,
    showLoading
  })
}

// 查询订单列表
export function queryTbOrderList (params, showLoading = true) {
  return request({
    url: '/order/queryTbOrderList',
    method: 'GET',
    params,
    showLoading
  })
}

// 查询订单产品列表
export function queryProductOrderList (params, showLoading = true) {
  return request({
    url: '/order/queryProductOrderList',
    method: 'GET',
    params,
    showLoading
  })
}

// 查询用户优惠券列表
// export function queryTbUserCouponPage (params, showLoading = true) {
//   return request({
//     url: '/coupon/queryTbUserCouponPage',
//     method: 'GET',
//     params,
//     showLoading
//   })
// }

// 获取临时验证码
export function smsVerificationTemporaryCode (data, showLoading = true) {
  return request({
    url: '/common/smsVerificationTemporaryCode',
    method: 'POST',
    data,
    showLoading
  })
}

// 获取用户信息
export function getAllSysUserInfo (params, showLoading = true) {
  return request({
    url: '/user/getAllSysUserInfo',
    method: 'GET',
    params,
    showLoading
  })
}

// ========== 总决选相关接口 ==========
// 查询总决选费用信息
export function queryNationalFeesInfo (params, showLoading = true) {
  return request({
    url: '/national/queryNationalFeesInfo',
    method: 'GET',
    params,
    showLoading
  })
}

// 确认支付V1
export function confirmPayV1 (data, showLoading = true) {
  return request({
    url: '/examinationUser/confirmPayV1',
    method: 'POST',
    data,
    showLoading
  })
}

// 获取订单信息
export function getTbOrderInfo (params, showLoading = true) {
  return request({
    url: '/order/getTbOrderInfo',
    method: 'GET',
    params,
    showLoading
  })
}

// 更新国赛支付状态
export function updateNationmatchPayed (params, showLoading = true) {
  return request({
    url: '/match/erp/updateNationmatchPayed',
    method: 'GET',
    params,
    showLoading
  })
}

// 获取国赛支付详情
export function getNationmatchPayedDetails (params, showLoading = true) {
  return request({
    url: '/match/erp/getNationmatchPayedDetails',
    method: 'GET',
    params,
    showLoading
  })
}

// 更新国赛支付详情
export function updateNationmatchPayedDetails (data, showLoading = true) {
  return request({
    url: '/match/erp/updateNationmatchPayedDetails',
    method: 'POST',
    data,
    showLoading
  })
}

// 导出总决选选手列表
export function exportTbEnrollmentNationalList (params, showLoading = true) {
  return request({
    url: '/overseasEnrollment/exportTbEnrollmentNationalList',
    method: 'GET',
    params,
    showLoading
  })
}

// 更新审核状态
export function updateNationReview (data, showLoading = true) {
  return request({
    url: '/enrollment/updateNationReview',
    method: 'POST',
    data,
    showLoading
  })
}

// 更新订单金额
export function updateOrderAmount (data, showLoading = true) {
  return request({
    url: '/order/updateOrderAmount',
    method: 'POST',
    data,
    showLoading
  })
}

// 更新订单产品
export function updateOrderProduct (data, showLoading = true) {
  return request({
    url: '/orderProduct/updateOrderProduct',
    method: 'POST',
    data,
    showLoading
  })
}

// 试卷管理
// 获取试卷列表
export function formQuizPageList (params, showLoading = true) {
  return request({
    url: '/formQuiz/pageList',
    method: 'GET',
    params,
    showLoading
  })
}
// 创建试卷
export function createFormQuiz (data, showLoading = true) {
  return request({
    url: '/formQuiz/create',
    method: 'POST',
    data,
    showLoading
  })
}

// 编辑试卷
export function editFormQuiz (data, showLoading = true) {
  return request({
    url: '/formQuiz/edit',
    method: 'POST',
    data,
    showLoading
  })
}

// 删除试卷
export function deleteFormQuiz (data, showLoading = true) {
  return request({
    url: '/formQuiz/del',
    method: 'POST',
    data,
    showLoading
  })
}
// 试卷详情
export function getFormQuizInfo (data, showLoading = true) {
  return request({
    url: '/formQuiz/info',
    method: 'POST',
    data,
    showLoading
  })
}
// 试卷详情
export function getFormQuizInfoConfront (params, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfront/info',
    method: 'GET',
    params,
    showLoading
  })
}
// 导出试卷列表
export function exportExcewlList (params, showLoading = true) {
  return request({
    url: '/formQuiz/exportExcewlList',
    method: 'GET',
    params,
    showLoading
  })
}
// 查询试卷题
export function queryQuizInfoPage (params, showLoading = true) {
  return request({
    url: '/formQuiz/queryQuizInfoPage',
    method: 'GET',
    params,
    showLoading
  })
}
// 查询试卷可用题型
export function queryQuizTypeList (params, showLoading = true) {
  return request({
    url: '/formQuiz/queryQuizTypeList',
    method: 'GET',
    params,
    showLoading
  })
}
export function queryQuizTypeListConfront (params, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/queryQuizTypeList',
    method: 'GET',
    params,
    showLoading
  })
}
// 修改试卷可用题型
export function updateQuizTypeList (data, showLoading = true) {
  return request({
    url: '/formQuiz/updateQuestionType',
    method: 'POST',
    data,
    showLoading
  })
}
// 修改试卷可用题型
export function updateQuizTypeListConfront (data, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/updateQuestionType',
    method: 'POST',
    data,
    showLoading
  })
}
// 根据试卷和题型查询试卷题
export function queryQuizInfoPageByFormQuizId (params, showLoading = true) {
  return request({
    url: '/formQuiz/queryQuizInfoListBYIdAndType',
    method: 'GET',
    params,
    showLoading
  })
}
// 根据试卷和题型查询试卷题
export function queryQuizInfoPageByFormQuizIdConfront (params, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/queryQuizInfoListBYIdAndType',
    method: 'GET',
    params,
    showLoading
  })
}
// 根据组别和试卷类型查询试卷题
export function queryQuizInfoPageByFormQuizIdAndType (params, showLoading = true) {
  return request({
    url: '/formQuiz/queryQuizInfoListBYLevelAndType',
    method: 'GET',
    params,
    showLoading
  })
}
// 根据组别和试卷类型查询试卷题
export function queryQuizInfoPageByFormQuizIdAndTypeConfront (params, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/queryQuizInfoListBYLevelAndType',
    method: 'GET',
    params,
    showLoading
  })
}
// 批量根据题型新建试题
export function batchCreateQuiz (data, showLoading = true) {
  return request({
    url: '/formQuiz/createBathByQuestionType',
    method: 'POST',
    data,
    showLoading
  })
}
// 批量根据题型新建试题
export function batchCreateQuizConfront (data, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/createBathByQuestionType',
    method: 'POST',
    data,
    showLoading
  })
}
// 删除题
export function deleteQuizInfo (data, showLoading = true) {
  return request({
    url: '/formQuiz/deleteQuizInfo',
    method: 'POST',
    data,
    showLoading
  })
}
// 删除题
export function deleteQuizInfoConfront (data, showLoading = true) {
  return request({
    url: '/overseasSchoolClassesConfrontQuizInfo/deleteQuizInfo',
    method: 'POST',
    data,
    showLoading
  })
}

// 时间管理相关接口
// 获取时间安排列表
export function getExamTimeList (params, showLoading = true) {
  return request({
    url: '/districtTime/v1/queryDistrictTimePage',
    method: 'GET',
    params,
    showLoading
  })
}
// 新增/修改时间安排（同一个接口）
export function saveOrUpdateExamTime (data, showLoading = true) {
  return request({
    url: '/districtTime/v1/saveOrUpdateDistrictTime',
    method: 'POST',
    data,
    showLoading
  })
}
// 删除时间安排
export function deleteExamTime (params, showLoading = true) {
  return request({
    url: '/districtTime/v1/deleteDistrictTime',
    method: 'GET',
    params,
    showLoading
  })
}

// C端答题获取比赛时间
export function getCompetitionTime (params, showLoading = true) {
  return request({
    url: '/raceSchedule/getSeasonRaceScheduleTime',
    method: 'GET',
    params,
    showLoading
  })
}
// C端答题获取答题状态
export function getCompetitionStatus (params, showLoading = true) {
  return request({
    url: '/formMatch/queryUserHasAnswered',
    method: 'GET',
    params,
    showLoading
  })
}
// C端答题获取比赛进度
export function getFormMatchProgress (params, showLoading = true) {
  return request({
    url: '/formMatch/getProgress',
    method: 'GET',
    params,
    showLoading
  })
}
// C端获取试卷信息
export function getCompetitionInfo (params, showLoading = true) {
  return request({
    url: '/formMatch/queryTheOnlineQuizForm',
    method: 'GET',
    params,
    showLoading
  })
}

// C端答题获取试卷题目分页
export function getOnlineQuizFormListPage (params, showLoading = true) {
  return request({
    url: '/formMatch/queryTheOnlineQuizFormListPage',
    method: 'GET',
    params,
    showLoading
  })
}

// C端答题获取进度条
export function getOnlineQuizProgressBar (data, showLoading = true) {
  return request({
    url: '/formMatch/queryTheProgressBar',
    method: 'POST',
    data,
    showLoading
  })
}

// C端答题查询题目答案回显
export function getOnlineFormAnswer (data, showLoading = true) {
  return request({
    url: '/formMatch/queryTheOnlineFormAnswer',
    method: 'POST',
    data,
    showLoading
  })
}

// C端答题保存本题答案
export function saveOnlineFormAnswer (data, showLoading = true) {
  return request({
    url: '/formMatch/saveTheOnlineFormAnswer',
    method: 'POST',
    data,
    showLoading
  })
}

// C端答题检查是否有未完成试题
export function checkOnlineQuizUnfinishedQuestions (params, showLoading = true) {
  return request({
    url: '/formMatch/queryWhetherUnfinishedQuestions',
    method: 'GET',
    params,
    showLoading
  })
}

// C端答题提交试卷
export function submitOnlineQuizMatchAnswer (data, showLoading = true) {
  return request({
    url: '/formMatch/saveQuizMatchAnswer',
    method: 'POST',
    data,
    showLoading
  })
}

// C端答题获取答题卡
export function getOnlineQuizMatchAnswerCard (data, showLoading = true) {
  return request({
    url: '/formMatch/queryQuizMatchAnswer',
    method: 'POST',
    data,
    showLoading
  })
}
// 海外合作申请
export function addOverseasContact (data, showLoading = true) {
  return request({
    url: '/common/overseasContactUs/add',
    method: 'POST',
    data,
    showLoading
  })
}
// 报名全球赛
export function nationalOverseas (data, showLoading = true) {
  return request({
    url: '/nationalOverseas/regist/add',
    method: 'POST',
    data,
    showLoading
  })
}
export function nationalOverseasCommon (data, showLoading = true) {
  return request({
    url: '/common/nationalOverseas/regist/add',
    method: 'POST',
    data,
    showLoading
  })
}
